export function createSemReporter({ appId, btAppId }) {
  const endpoint = 'https://sdkserver.seasungame.com/api/clue';
  const storageKey = 'device_id';
  let memoryDeviceId = '';

  function getDeviceId() {
    if (memoryDeviceId) return memoryDeviceId;
    try {
      memoryDeviceId = window.localStorage.getItem(storageKey) || '';
    } catch (error) {
      memoryDeviceId = '';
    }
    if (!memoryDeviceId) {
      memoryDeviceId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
        const random = (Math.random() * 16) | 0;
        const value = character === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
      });
      try {
        window.localStorage.setItem(storageKey, memoryDeviceId);
      } catch (error) {
        return memoryDeviceId;
      }
    }
    return memoryDeviceId;
  }

  async function sendSemReport(eventId) {
    try {
      if (!appId || !btAppId || !eventId) {
        throw new Error('SEM 缺少 appId、btAppId 或 eventId');
      }
      const currentUrl = new URL(window.location.href);
      const payload = {
        url: currentUrl.href,
        appId,
        btAppId,
        deviceId: getDeviceId(),
        msgType: 'custom.event',
        eventId,
        _btcode: currentUrl.searchParams.get('_btcode') || 'null',
        bd_vid: currentUrl.searchParams.get('bd_vid') || 'null'
      };
      const body = encodeURIComponent(JSON.stringify(payload));
      const response = await window.fetch(`${endpoint}?body=${body}`);
      if (!response.ok) {
        throw new Error(`SEM HTTP ${response.status}`);
      }
      const data = await response.json();
      return { status: 'received', data };
    } catch (error) {
      return { status: 'failed', error };
    }
  }

  return { getDeviceId, sendSemReport };
}

const sem = createSemReporter({ appId: '200001658', btAppId: '5891adafd625' });

export const sendSemReport = sem.sendSemReport;
